import {UseFormReturn} from 'react-hook-form';
import {
    fullRightCreate,
    fullRightIsValid,
    fullRightParse,
    getAdminRights,
    inputNamesInSections,
    isCanView,
} from '../../helpers';
import {UIRenderableElement} from '../../types';

export const rightsCheckFullAccount = (
    name: string,
    values: Partial<Record<string, unknown>>,
) => {
    const keys = inputNamesInSections([
        'document_approval',
        'documents',
        'other',
        'bookkeeping',
    ]).filter((n) => !isCanView(n));

    const key = keys.find((k) => k === name);
    if (!key) return true;

    return values.user_license === 'full_account_user';
};

export const rightsCheckSalesManagement = (
    name: string,
    values: Partial<Record<string, unknown>>,
) => {
    const keys = inputNamesInSections([
        'document_approval',
        'documents',
        'other',
        'bookkeeping',
    ]);

    const key = keys.find((k) => k === name);
    if (!key) return true;

    return values.sales_mgmt_license === true;
};

export const rightsCheckTimeTracking = (
    name: string,
    values: Partial<Record<string, unknown>>,
) => {
    const keys: string[] = [
        'rights.timesheet.can_view',
        'rights.timesheet.can_create',
        'rights.timesheet.can_cancel',
    ];
    const key = keys.find((k) => k === name);
    if (!key) return true;

    return values.time_tracking === false;
};

export const rightsCheckDisabled = (
    name: string,
    uiElements: UIRenderableElement[],
) => {
    const keys = getAdminRights(uiElements).flatMap((r) =>
        r.actions.map((a) => fullRightCreate('rights', r.name, a.name)),
    );

    const key = keys.find((k) => k === name);

    return !key;
};

export const rightsCheckCanView = (
    methods: UseFormReturn,
    fullRight: string,
) => {
    if (!fullRightIsValid(fullRight)) return true;
    if (isCanView(fullRight)) return true;

    const {base, category} = fullRightParse(fullRight);

    return methods.getValues(fullRightCreate(base, category, 'can_view'));
};
